(() => {
  const root = document.querySelector('.cs-shop[data-sa-shop]');
  if (!root || root.dataset.saReady) return;
  root.dataset.saReady = 'true';
  const cn = document.documentElement.lang.startsWith('zh');
  const dialog = root.querySelector('[data-sa-dialog]');
  const body = dialog.querySelector('[data-sa-dialog-body]');
  let opener, selected, adding = false;
  const categoryParam = 'filter.p.product_type';
  const syncCategories = () => {
    const values = new URL(location.href).searchParams.getAll(categoryParam).flatMap(v => v.split(','));
    root.querySelectorAll('[data-sa-category]').forEach(a => {
      const v = a.dataset.saCategory;
      const active = v ? values.includes(v) : !values.length;
      a.toggleAttribute('aria-current', active);
      if (active) a.setAttribute('aria-current', 'true');
      const url = new URL(location.href);
      url.searchParams.delete(categoryParam); url.searchParams.delete('page');
      if (v) url.searchParams.set(categoryParam, v);
      a.href = url.pathname + url.search;
    });
  };
  const syncStock = () => {
    const active = new URL(location.href).searchParams.get('filter.v.availability') === '1';
    root.querySelectorAll('[data-sa-stock]').forEach(a => {
      a.toggleAttribute('aria-current', active); if (active) a.setAttribute('aria-current', 'true');
      const url = new URL(location.href);url.searchParams.delete('page');url.searchParams.delete('filter.v.availability');
      if (!active) url.searchParams.set('filter.v.availability', '1');a.href=url.pathname+url.search;
    });
  };
  root.querySelector('[data-cs-jump]')?.addEventListener('change', e => {if (e.target.value) location.assign(e.target.value);});
  syncCategories();syncStock();
  new MutationObserver(syncStock).observe(root.querySelector('#ProductGridContainer'), {childList:true});
  window.addEventListener('popstate', syncStock);
  new MutationObserver(syncCategories).observe(root.querySelector('#ProductGridContainer'), {childList:true});
  window.addEventListener('popstate', syncCategories);

  function switchCategory(a) {
    location.assign(a.href);
  }

  async function loadMore(a) {
    if (a.getAttribute('aria-disabled') === 'true') return;
    const priorURL = location.href;
    const oldGrid = root.querySelector('#product-grid');
    const request = new URL(a.href);
    request.searchParams.set('section_id', root.dataset.section);
    a.setAttribute('aria-disabled', 'true');
    a.textContent = cn ? '加载中…' : 'Loading…';
    try {
      const response = await fetch(request);
      if (!response.ok) throw Error('Load failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = html.querySelector('#product-grid');
      const more = html.querySelector('[data-sa-more]');
      if (!grid || !more) throw Error('Incomplete page');
      if (location.href !== priorURL || !oldGrid.isConnected) return;
      const existing = new Set(Array.from(oldGrid.children).map(el=>el.dataset.saProduct));
      const additions = Array.from(grid.children).filter(el=>!existing.has(el.dataset.saProduct));
      additions.forEach(el => {el.classList.add('scroll-trigger--cancel');oldGrid.append(el);});
      root.querySelector('[data-sa-more]').replaceWith(more);
      const firstLink = additions[0]?.querySelector('.card__heading a');
      if (firstLink) firstLink.focus({preventScroll:true});
      root.querySelector('[data-sa-announcement]').textContent = cn ? `已加载 ${additions.length} 件商品` : `${additions.length} more pieces loaded`;
    } catch (error) {
      if (!a.isConnected) return;
      a.removeAttribute('aria-disabled');
      a.textContent = a.dataset.label;
      const status = root.querySelector('[data-sa-more-error]');
      status.hidden = false;
      status.textContent = cn ? '暂时无法加载，请再次点击重试。' : 'Unable to load. Please tap again to retry.';
    }
  }

  function closeDialog() {
    if (adding) return;
    dialog.close();
  }
  dialog.addEventListener('close', () => {
    document.body.classList.remove('sa-dialog-open');
    opener?.focus({preventScroll:true});
  });
  dialog.addEventListener('cancel', event => {if (adding) event.preventDefault();});
  dialog.addEventListener('click', event => {if (event.target === dialog) closeDialog();});

  async function addSelected(button) {
    if (!selected || adding) return;
    adding = true; button.disabled = true;
    button.textContent = cn ? '正在加入…' : 'Adding…';
    const error = body.querySelector('[data-sa-error]'); error.hidden = true;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const form = new FormData(); form.append('id', selected);form.append('quantity', '1');
    if (cart?.getSectionsToRender) {
      form.append('sections', cart.getSectionsToRender().map(section=>section.id).join(','));
      form.append('sections_url', location.pathname);
      cart.setActiveElement?.(opener);
    }
    try {
      const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:form});
      const result = await response.json();
      if (!response.ok || result.status) throw Error(result.description || (cn ? '此规格暂时无法加入购物车，请重新选择。' : 'This option is unavailable. Please choose another.'));
      adding = false; dialog.close();
      if (cart?.renderContents) {
        cart.classList.remove('is-empty');
        try {cart.renderContents(result);} catch (_) {location.assign(window.routes?.cart_url || '/cart');}
      } else location.assign(window.routes?.cart_url || '/cart');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {source:'category-studio-quick-add',productVariantId:selected,cartData:result});
      }
    } catch (err) {
      error.textContent = err.message || (cn ? '未能加入，请重试。' : 'Unable to add. Please try again.');error.hidden = false;
    } finally {
      adding = false; button.disabled = false;button.textContent = button.dataset.label;
    }
  }

  root.addEventListener('click', event => {
    const category = event.target.closest('[data-sa-category], [data-sa-stock]');
    if (category && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {event.preventDefault();switchCategory(category);return;}
    const next = event.target.closest('[data-sa-next]');
    if (next && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {event.preventDefault();loadMore(next);return;}
    const trigger = event.target.closest('[data-sa-open]');
    if (trigger) {
      const template = document.getElementById(trigger.dataset.saOpen);
      if (!template) return;
      opener = trigger;selected = null;
      body.replaceChildren(template.content.cloneNode(true));
      document.body.classList.add('sa-dialog-open');dialog.showModal();
      dialog.querySelector('[data-sa-close]').focus();return;
    }
    const variant = event.target.closest('[data-sa-variant]');
    if (variant && !variant.disabled && !adding) {
      selected = variant.dataset.saVariant;
      body.querySelectorAll('[data-sa-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b===variant)));
      body.querySelector('[data-sa-price]').textContent = variant.dataset.saPrice;
      const add = body.querySelector('[data-sa-add]');add.disabled=false;add.textContent=add.dataset.label;
      body.querySelector('[data-sa-error]').hidden=true;return;
    }
    if (event.target.closest('[data-sa-close]')) closeDialog();
    const add = event.target.closest('[data-sa-add]');if (add) addSelected(add);
  });
})();
